export default "__VITE_ASSET__57dca4cb__"